/**
 * Story 057 — TanStack Query keys for the turbines feature.
 */
import type { ListTurbinesParams } from "./types.js";

export const turbinesKeys = {
  all: ["turbines"] as const,
  lists: () => [...turbinesKeys.all, "list"] as const,
  list: (params: ListTurbinesParams) =>
    [...turbinesKeys.lists(), params] as const,
  detail: (id: string) => [...turbinesKeys.all, "detail", id] as const,
  assetModels: (assetTypeId: string | null) =>
    [...turbinesKeys.all, "asset-models", assetTypeId ?? "__all__"] as const,
};
